import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const CaretRight = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.73214 6.875C9.89658 6.875 10.0389 6.93508 10.159 7.05525L14.409 11.3052C14.5292 11.4254 14.5893 11.5677 14.5893 11.7321C14.5893 11.8966 14.5292 12.0389 14.409 12.159L10.159 16.409C10.0389 16.5292 9.89658 16.5893 9.73214 16.5893C9.56771 16.5893 9.42541 16.5292 9.30525 16.409C9.18508 16.2889 9.125 16.1466 9.125 15.9821V7.48214C9.125 7.31771 9.18508 7.17541 9.30525 7.05525C9.42541 6.93508 9.56771 6.875 9.73214 6.875Z"
        />
    </StarryUIIcon>
);
